import { render, staticRenderFns } from "./HotelRoomArrangements.vue?vue&type=template&id=d58d6ec6&scoped=true&"
import script from "./HotelRoomArrangements.vue?vue&type=script&lang=js&"
export * from "./HotelRoomArrangements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58d6ec6",
  null
  
)

export default component.exports